<script setup lang="ts">
const appStateStore = useAppStateStore();
</script>

<template>
  <Transition mode="out-in">
    <div v-if="appStateStore.isLoggingIn" class="mt-3">
      <div class="hidden md:flex items-center gap-5">
        <div class="flex gap-2 items-center">
          <BaseIconWalletSkeleton />
          <p class="w-28 h-4 bg-neutral-600 rounded-xl"></p>
        </div>
        <NuxtIcon name="mdi:bell" class="text-[32px] text-neutral-600" />
        <div class="flex items-center gap-1">
          <BaseIconAvatar class="w-12" />
          <NuxtIcon
            name="mdi:keyboard-arrow-down"
            class="-mr-1 text-2xl transition-all duration-300 text-neutral-600" />
        </div>
      </div>
      <div class="md:hidden">
        <NuxtIcon
          name="mdi:user-outline"
          class="text-4xl animate-pulse text-neutral-300" />
      </div>
    </div>
    <div v-else class="relative flex items-center gap-5 mt-3">
      <HeaderAccountBalance />
      <HeaderAccountNotifications />
      <HeaderAccountUserMenu />
    </div>
  </Transition>
</template>
<style scoped>
.v-enter-active {
  transition: all 0.3s ease-out;
}
.v-enter-from {
  opacity: 0;
  transform: translate(0, 1rem);
}
.v-enter-to {
  opacity: 1;
  transform: translate(0, 0);
}
.v-leave-active {
  transition: all 0.2s ease-in;
}
.v-leave-from {
  opacity: 1;
  transform: translate(0, 0);
}
.v-leave-to {
  opacity: 0;
  transform: translate(0, 1rem);
}
@media (min-width: 640px) {
  .v-enter-from,
  .v-leave-to {
    transform: translate(0, 0) scale(0.95);
  }
  .v-enter-to,
  .v-leave-from {
    transform: translate(0, 0) scale(1);
  }
}
</style>
